<template>
    <div class="main-width">
        <div class="location_css">
            <img src="../../assets/img/location.png">
            <div>当前位置：</div>
            <div @click="goSy()">首页</div>
            <div> <i class="el-icon-arrow-right"></i> </div>
            <div @click="goProduct()">产品追溯</div>
            <div> <i class="el-icon-arrow-right"></i> </div>
            <div @click="goProduct()">{{companyName}}</div>
            <div> <i class="el-icon-arrow-right"></i> </div>
            <div class="location_text">{{selectData.wineName}}</div>
        </div>
        <div class="culture_main" v-loading="loading">
            <div class="culture_left">
                <div class="culture_left_title">产品列表</div>
                <div>
                    <div class="culture_left_item" v-for="(item,index) in productList" :key="index" @click="select(item)">
                        <div style="display: flex;">
                            <div class="culture_left_item_text" :class="{'culture_active':item.wineId == selectData.wineId}">
                                <i class="el-icon-caret-right" style="margin-right: 9px"></i>{{item.wineName}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="culture_right">
                <div class="culture_right_title">
                    <div class="culture_right_text">
                        <img src="../../assets/img/jiujia.png" style="width: 19px;height: 21px;">
                        <div>{{selectData.restaurantName}}</div>
                    </div>
                </div>
                <div class="company_item">
                    <div style="display: flex;">
                        <img class="company_img" :src="selectData.wineImage" style="width: 204px;height: 265px;">
                        <div>
                            <div class="company_title">{{selectData.wineName}}</div>
                            <div class="company_content" style="text-indent: 0px;"><span style="color: #121D29;font-weight: 600">价格：</span>{{selectData.winePrice}}</div>
                            <div class="company_content" style="text-indent: 0px;"><span style="color: #121D29;font-weight: 600">净含量：</span>{{selectData.wineSpec}}</div>
                            <div class="company_content" style="text-indent: 0px;"><span style="color: #121D29;font-weight: 600">酒精度：</span>{{selectData.wineAbv}}</div>
                        </div>
                    </div>
                    <!--酒家轶事-->
                    <div>
                        <div class="company_title">产品介绍</div>
                        <div class="company_content">{{selectData.wineDescription}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            storeList: [],
            loading: false,
            selectData: {},
            productList: [],
            companyName: ""
        }
    },
    methods: {
        //回退
        goProduct: function() {
            this.$router.push({
                path: "/product",
            });
        },
        //获取商家产品
        getProductList: function() {
            let vue = this;
            return new Promise((resolve, reject) => {
                this.$axios.get("fx-web/wine/page/wine", { params: { Id: this.$route.query.id, pageNum: 1, pageSize: 10000 } }).then(function(resp) {
                    if (resp.errcode == 0 || resp.errcode == "0") {
                        vue.productList = resp.data.dataList;
                    } else {
                        vue.$message.warning(resp.errtext);
                    };
                    vue.loading = false;
                    resolve();
                }, function() {
                    vue.loading = false;
                    resolve();
                });
            });
        },
        //选择酒家
        select: function(data) {
            var vue = this;
            this.selectData = data;
        }
    },
    mounted() {
        let vue = this;
        vue.loading = true;
        this.companyName = this.$route.query.companyname;
        this.getProductList().then(function() {
            var temp = {};
            for (var i = 0; i < vue.productList.length; i++) {
                if (vue.productList[i].wineId == vue.$route.query.wineid) {
                    temp = vue.productList[i];
                    break;
                };
            };
            vue.select(temp);
        });
        // this.getAllStore().then(function() {
        //     vue.select(vue.storeList[0]);
        // }).then(vue.getProduct);
    }
}
</script>